import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';

// The public scores screens show every tab at once: a wrapping row of buttons
// instead of a scrolling tab bar, so no tab hides behind scroll arrows on a
// phone.
const EmbeddedTabButtons = ({ tabs, value, onChange, ariaLabel }) => (
  <Box
    role="tablist"
    aria-label={ariaLabel}
    display="flex"
    flexWrap="wrap"
    justifyContent="center"
    alignItems="center"
    gap={1}
    px={1}
    py={1}>
    {tabs.map(({ label, value: tabValue, disabled = false }) => (
      <Button
        key={tabValue}
        id={`tab-${tabValue}`}
        role="tab"
        aria-selected={value === tabValue}
        aria-controls={`tabpanel-${tabValue}`}
        size="small"
        variant={value === tabValue ? 'contained' : 'outlined'}
        disabled={disabled}
        onClick={() => onChange(tabValue)}>
        {label}
      </Button>
    ))}
  </Box>
);

EmbeddedTabButtons.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.number.isRequired,
      disabled: PropTypes.bool
    })
  ).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string
};

export default EmbeddedTabButtons;
